<div>
    <div class="bottom-bot-div" [ngClass]="{
        'invalid-phone-border': isAskingPhoneToEnter && 
                                !phoneForm.valid && phoneForm.value?.phone?.number?.length > 2,
        'invalid-email-border': isAskingEmailToEnter && !isValidEmail(message) && message.length >2
      }">

        <div class="child1">
            <div class="left_bottom">
                <div (click)="toggleMenuButton()" style="cursor: pointer" *ngIf="!isLiveChat">
                    <i class="fas fa-bars" style="font-size: 17px;margin-left: 7px;"></i>
                </div>

                <div (click)="fnOpenSmallModal(CloseLiveChatAgent)" style="cursor: pointer; color: red;"
                    *ngIf="isLiveChat">
                    <i class="fas fa-comment-slash" style="font-size: 17px; margin-left: 7px;"
                        title="Close Live Chat Agent"></i>
                </div>
                <!-- <div>
                    <img src="../assets/images/botv2/Vector 13.png" alt="" />
                </div> -->
                <button *ngIf="IsEmoji" class="emoji-button"
                    [disabled]="messages.length > 0 && (messages[messages.length - 1].widgetType === 'Date' ||messages[messages.length - 1].widgetType === 'Time')"
                    (click)="isEmojiPickerVisible = !isEmojiPickerVisible;">
                    <i class="fas fa-laugh custom-icon-color" style="width: 18px; height: 18px; align-self: center"></i>

                </button>
            </div>

            <emoji-mart class="emoji-mart" *ngIf="isEmojiPickerVisible" (emojiSelect)="addEmoji($event)"
                title="Choose your emoji"
                [style]="{ position: 'absolute', bottom: '60px', right: '20px' , backgroundColor: 'white', color:'black'}"></emoji-mart>

        </div>
        <div class="child2">
            <input #messageInput type="text" style="background-color: transparent;" *ngIf="!isAskingPhoneToEnter"
                [disabled]="
                     makeInputDisabled || isTyping || isAskingForAppRating ||
              messages.length > 0 &&
              (messages[messages.length - 1].widgetType === 'Date' || 
              messages[messages.length - 1].widgetType === 'Time')" (keyup.enter)="handleEventEnter()"
                [(ngModel)]="message" [ngClass]="{ 'invalid-input': isAskingEmailToEnter && !isValidEmail(message) }"
                [placeholder]="isAskingEmailToEnter ? 'Enter your email (e.g., name@example.com)' : 'Type a message'"
                class="input-element" />

            <form [formGroup]="phoneForm" (ngSubmit)="onSubmit()" style="width: 100%;" *ngIf="isAskingPhoneToEnter">
                <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="['in','de']"
                    [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                    (keyup.enter)="onSubmit()" [selectFirstCountry]="true" [formControlName]="'phone'" [maxLength]="15">
                </ngx-intl-tel-input>

                <button style="width: 15%;
                border: none;
                background: transparent;
                " type="submit" [disabled]="!phoneForm.valid" class="send-btn"
                    [style.cursor]="!phoneForm.valid ? 'not-allowed' : 'pointer'">
                    <i class="fas fa-paper-plane"></i>
                </button>
            </form>

            <div *ngIf="isAskingPhoneToEnter && !phoneForm.valid && phoneForm.value?.phone?.number?.length > 2">
                <div class="invalid-phone-text">Please enter a valid phone number</div>
            </div>

            <div *ngIf="isAskingEmailToEnter && !isValidEmail(message) && message.length > 2">

                <div class="invalid-phone-text">Please enter a valid email</div>

            </div>


        </div>

        <div (click)="handleEventEnter()" *ngIf="!isAskingPhoneToEnter" [style.cursor]="
          (isTyping || 
          messages.length > 0 &&
          (messages[messages.length - 1].widgetType === 'Date' || 
          messages[messages.length - 1].widgetType === 'Time') || 
          (isAskingEmailToEnter && !isValidEmail(message)))
            ? 'not-allowed'
            : 'pointer'" [class.disabled]="isAskingEmailToEnter && !isValidEmail(message)" class="child3">
            <i class="fas fa-paper-plane"></i>
        </div>


        <div *ngIf="isVoice" class="child4"><i (click)="startListening()"
                [ngClass]="(this.isListening ? 'mic_active fa fa-microphone' :'fa fa-microphone')"></i></div>


    </div>
    <div class="powered-by">

        <div class="powered-by-text">
            Powered By
        </div>

        <div class="powered-by-logo">
            <a href="https://www.gravitas.ai/" target="_blank">
                <img src="../assets/images/logo.png" alt="" class="powered-by-logo-image" />
            </a>
        </div>

        <div class="client_logo" *ngIf="this.client_logo">
            <a [href]="clientRedirectUrl" target="_blank">

                <img class="powered-by-logo-image" [src]="this.client_logo" />
            </a>
        </div>


    </div>
</div>


<div *ngIf="isMenuVisible" style="position: relative;" appClickOutside (clickOutside)="handleClickOutside()">

    <div class="menu-container">
        <div class="menu-style" *ngIf="clientMenu == undefined || clientMenu.length == 0">
            <div class="close-icon" (click)="handleClickOutside()">
                &times;
            </div>
            <div class="menu-style-gap">
                <div class="menu-box" (click)="handleClick('menu')">
                    <i class="fa-solid fa-border-all custom-icon-color"
                        style="width: 18px; height: 18px; align-self: center"></i>
                    <div class="menu-button custom-icon-color">Main Menu</div>

                    <div class="vertical_box">
                        <img src="../assets/images/botv2/vertical_line.png" alt="" style="display: none;" />
                    </div>
                </div>
                <div class="menu-box" *ngIf="isFileUpload" (click)="handleOpenFileUplaodModel()">

                    <i class="fa-solid fa-paperclip custom-icon-color"
                        style="width: 18px; height: 18px; align-self: center"></i>
                    <div class="menu-button custom-icon-color">Attach</div>
                    <div class="vertical_box">
                        <img src="../assets/images/botv2/vertical_line.png" alt="" style="display: none;" />
                    </div>
                </div>


                <div class="menu-box" *ngIf="isDownloadTranscript" (click)="generatePDF()">

                    <i class="fa-solid fa-download custom-icon-color"
                        style="width: 18px; height: 18px; align-self: center"></i>
                    <div class="menu-button custom-icon-color">Download</div>
                    <div class="vertical_box">
                        <img src="../assets/images/botv2/vertical_line.png" alt="" style="display: none;" />
                    </div>

                </div>

                <div class="menu-box" *ngIf="isShowPayment" (click)="handleAddPayment()">

                    <i class="fas fa-wallet custom-icon-color"
                        style="width: 18px; height: 18px; align-self: center"></i>
                    <div class="menu-button custom-icon-color">Payement</div>
                    <div class="vertical_box">
                        <img src="../assets/images/botv2/vertical_line.png" alt="" style="display: none;" />
                    </div>

                </div>
            </div>
            <div *ngIf="isShowHelp" (click)="handleClickOnHelp()">
                <div class="menu-box">
                    <i class="fa-solid fa-question custom-icon-color" style="width: 18px; height: 18px;
                    display: flex; justify-content: center;
                    align-self: center"></i>

                    <div class="menu-button  custom-icon-color">Help</div>
                </div>
            </div>
        </div>
        <div class="menu-style dynamic-menu-container" *ngIf="clientMenu !== undefined && clientMenu.length > 0">
            <div class="close-icon" (click)="handleClickOutside()">
                &times;
            </div>
            <div *ngFor="let menu of clientMenu" class="dynamic-menu">
                <div (click)="handleClick(menu)">
                    {{ menu.text }}
                </div>
            </div>


        </div>
    </div>
</div>

<ng-template #CloseLiveChatAgent let-modal>
    <div class="modal-header">
        <h4 class="modal-title live-chat-header" id="modal-basic-title" style="    margin-top: -2px;
    font-size: 18px;">
            Close Live Chat Agent
        </h4>
        <div (click)="fnCloseModal()" class="close-button">
            <div class="close-cross">
                x
            </div>
        </div>
    </div>
    <div class="modal-body">


        <div class="form-group" style="font-weight: 600;
          text-align: center;
          font-size: 17px;">
            Are you Sure you want to close the chat?
        </div>

        <div style="text-align: center;"><button type="button" (click)="closeLiveChat()" class="custlivechatbtn2">
                Close Chat
            </button></div>
    </div>
</ng-template>